import { render, staticRenderFns } from "./SupplierBranchesControl.vue?vue&type=template&id=d787b676&"
import script from "./SupplierBranchesControl.vue?vue&type=script&lang=js&"
export * from "./SupplierBranchesControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports